import makeEditContext from './makeEditContext';

export const { Provider: EditDialogContextProvider, useContext: useEditDialogContext } =
  makeEditContext();
